import { MeshStandardMaterial } from 'three'
import gsap from 'gsap'

export class PhoneModel {
    constructor({ loader, assetsBase = '', envMap, parent }) {
        this.sizeElement = 2.0
        this.smallSize = 1.4
        this.rotSpeed = 0.001
        this.rotDir = 1
        this.minRot = 3.2
        this.maxRot = 2.6
        this.spinning = false

        this.mesh = null
        this.screenMesh = null

        this.screenMeshReady = new Promise((resolve) => {
            this._resolveScreenMesh = resolve
        })
        this.meshReady = new Promise((resolve) => {
            this._resolveMesh = resolve
        })

        loader.load(`${assetsBase}/3d/phone_1.glb`, (gltf) => {
            const stone = gltf.scene

            stone.traverse((node) => {
                if (!node.isMesh) return
                node.castShadow = true
                node.receiveShadow = false
            /*    node.material.metalness = 0.6
                node.material.roughness = 0.12
                node.material.envMapIntensity = 0*/
                console.log(node.name);

                if (node.name === 'Plane058' || node.name === 'Plane057') {
                   // node.visible = false
                }

                if (node.name === 'Body_Wallpaper_0') {
                    node.material = new MeshStandardMaterial({
                        color: '#ff0000',
                        metalness: 0.4,
                        roughness: 0.2,
                        envMap,
                        envMapIntensity: 1.0,
                    })
                    this.screenMesh = node
                    this._resolveScreenMesh(node)
                }
            })

            stone.scale.setScalar(this.sizeElement)
            stone.position.set(0, 0.2, 0)
            stone.rotation.y = 1

            this.mesh = stone
            parent.add(stone)
            this._resolveMesh(stone)
        })
    }

    popUp() {
        if (!this.mesh) return
        this.mesh.scale.setScalar(this.smallSize)
        gsap.to(this.mesh.scale, {
            duration: 0.3,
            ease: 'bounce.out',
            x: this.sizeElement,
            y: this.sizeElement,
            z: this.sizeElement,
        })
    }

    rotate() {
        if (!this.mesh) return
        this.spinning = true
        const currRotate = this.mesh.rotation.y
        gsap.to(this.mesh.rotation, {
            duration: 0.6,
            ease: 'power1.out',
            y: currRotate + Math.PI * 2,
            onComplete: () => { this.spinning = false },
        })
    }

    update() {
        if (!this.mesh || this.spinning) return

        if (this.mesh.rotation.y > this.minRot) {
            this.rotDir = -1
            this.mesh.rotation.y = this.minRot
        }
        if (this.mesh.rotation.y < this.maxRot) {
            this.rotDir = 1
            this.mesh.rotation.y = this.maxRot
        }
        this.mesh.rotation.y += this.rotSpeed * this.rotDir
    }
}
